import _ from '@/common/helpers';
import ColumnSet from '@/components/grid/columns/column-set';
import store from '@/store';
import BADGES_COLOR_MAP from '@/data/badges-color-map';
import auth from '@/common/auth/auth';
import bytes from '@/common/format/bytes';

export default function createColumns({
    onRowDownload,
    onRowEdit,
    onRowDelete,
    checkActionIsEnabled,
}) {
    return new ColumnSet({
        id: 'data-exports-list',
        store,
        version: 11,
        defaultColumns: [
            {
                name: 'scheduledTime',
                type: 'datetime',
                sortable: true,
                sticky: true,
            },
            {
                name: 'name',
                sortable: true,
            },
            {
                name: 'resource',
                value: row => _.capitalize(row.resource),
                sortable: true,
            },
            {
                name: 'recordCount',
                header: 'Items',
                type: 'numeric',
                format: 'integer',
                // eslint-disable-next-line no-confusing-arrow
                value: row => _.isBlank(row.recordCount)
                    ? '-'
                    : +row.recordCount,
            },
            {
                name: 'createdBy',
                value: row => `${row._embedded.user.firstName} ${row._embedded.user.lastName} (${row._embedded.user.email})`,
                sortable: true,
            },
            {
                name: 'status',
                type: 'badge',
                map: BADGES_COLOR_MAP.status,
                sortable: true,
            },
        ],
        lockedColumns: [
            {
                header: false,
                type: 'nested',
                style: {textRight: true},
                columns: [
                    {
                        type: 'button',
                        style: {
                            preset: 'download',
                            tooltip: 'download',
                        },
                        enabled: ({rowData}) => checkActionIsEnabled({name: 'download', rowData}),
                        click: ({rowData}) => onRowDownload({rowData}),
                        predicate: auth.$pages['data-exports'].isAllowed,
                    },
                    {
                        type: 'button',
                        style: {
                            preset: 'edit',
                            tooltip: 'edit',
                        },
                        enabled: ({rowData}) => checkActionIsEnabled({name: 'edit', rowData}),
                        click: ({rowData}) => onRowEdit({rowData}),
                        predicate: auth.$pages['update-data-export'].isAllowed,
                    },
                    {
                        type: 'button',
                        style: {
                            preset: 'delete',
                            tooltip: 'delete',
                        },
                        enabled: ({rowData}) => checkActionIsEnabled({name: 'delete', rowData}),
                        click: ({rowData, grid}) => onRowDelete({rowData, grid}),
                        predicate: auth.$pages['update-data-export'].isAllowed,
                    },
                ],
            },
        ],
        otherColumns: [
            {
                name: 'linked.file.size',
                header: 'File size',
                // eslint-disable-next-line no-confusing-arrow
                value: row => row._embedded.file && row._embedded.file.size ? bytes(row._embedded.file.size) : 'N/A',
            },
        ],
    });
}
